import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';

@Component({
  selector: 'app-add-seats-ancilliaries-screen',
  templateUrl: './add-seats-ancilliaries-screen.component.html',
  styleUrls: ['./add-seats-ancilliaries-screen.component.scss']
})
export class AddSeatsAncilliariesScreenComponent implements OnInit {
  isShow: boolean = true;
  seats: any = [
    { chair: 'Wheelchair-2-BA-Arranged' },
    { chair: 'Wheelchair-3-BA-Arranged' },
    { chair: 'Hard-of-Hearing-Assistance' },
    { chair: 'Visually-Impaired-Assistance' },
    { chair: 'Wheelchair-1-Customer-Manual' },
    { chair: 'Wheelchair-2-Customer-Manual' },
    { chair: 'Wheelchair-3-Customer-Manual' },
    { chair: 'Learning-Disability-Assistance' },
    { chair: 'Wheelchair-1-Customer-Drycell-Key' },
    { chair: 'Wheelchair-1-Customer-Lithium-Key' },
    { chair: 'Wheelchair-1-Customer-Wetcell-Key' },
    { chair: 'Wheelchair-2-Customer-Drycell-Key' },
    { chair: 'Wheelchair-2-Customer-Lithium-Key' },
    { chair: 'Wheelchair-2-Customer-Wetcell-Key' },
    { chair: 'Wheelchair-3-Customer-Drycell-Key' },
    { chair: 'Wheelchair-3-Customer-Lithium-Key' },
    { chair: 'Wheelchair-3-Customer-Wetcell-Key' },
    { chair: 'Wheelchair-1-Customer-Drycell-PlugD' },
    { chair: 'Wheelchair-1-Customer-Lithium-PlugD' },
    { chair: 'Wheelchair-1-Customer-Wetcell-PlugD' },
    { chair: 'Wheelchair-2-Customer-Drycell-PlugD' },
    { chair: 'Wheelchair-2-Customer-Lithium-PlugD' },
    { chair: 'Wheelchair-2-Customer-Wetcell-PlugD' },
    { chair: 'Wheelchair-3-Customer-Drycell-PlugD' },
    { chair: 'Wheelchair-3-Customer-Lithium-PlugD' },
    { chair: 'Wheelchair-3-Customer-Wetcell-PlugD' },
    { chair: 'Wheelchair-1-Customer-Drycell-Batt' },
    { chair: 'Wheelchair-1-Customer-Lithium-Batt' },
    { chair: 'Wheelchair-1-Customer-Wetcell-Batt' },
    { chair: 'Wheelchair-2-Customer-Drycell-Batt' },
    { chair: 'Wheelchair-2-Customer-Lithium-Batt' },
    { chair: 'Wheelchair-2-Customer-Wetcell-Batt' },
    { chair: 'Wheelchair-3-Customer-Drycell-Batt' },
    { chair: 'Wheelchair-3-Customer-Lithium-Batt' },
    { chair: 'Wheelchair-3-Customer-Wetcell-Batt' }
  ];

  public getDisabilityServiceDetail: any = [];
  disabilityServiceXmlParse: any;
  segmentList: any;
  flightList: any;
  priceClassList: any;
  public flightListIds: any = [];
  public flightSegment: any = [];
  public disabilityServicePrices: any = [];
  public disabilityService: any = [];
  public disabilityServiceScreenData: any = [];
  public disabilityServiceRefs: any = [];
  public disabilityServiceDetails: any = [];
  public disabilityServicedropDownList: any = [];

  constructor(private http: HttpClient, private sandboxPageStateService: SandboxPageStateService, private xmlToJsonParserService: XmlToJsonParserService) {}

  ngOnInit(): void {
    this.http.get('/assets/json/add-meal-service-response/add-meal-screen-response.xml', { responseType: 'text' }).subscribe((res: any) => {
      this.disabilityServiceXmlParse = this.xmlToJsonParserService.parseXMLToJSON(res);
      this.mapToDisablityServiceScreen();
    });
  }
  servHide() {}

  mapToDisablityServiceScreen() {
    let seatEnvelope = this.disabilityServiceXmlParse['SOAP:ENVELOPE'];
    let seatBody = seatEnvelope['SOAP:BODY'][0];
    let searviceListReponse = seatBody.SERVICELISTRS[0];
    let offersItems = searviceListReponse.ALACARTEOFFER[0].ALACARTEOFFERITEM;
    let dataList = searviceListReponse.DATALISTS[0];
    let serviceDefinitionList = dataList.SERVICEDEFINITIONLIST[0].SERVICEDEFINITION;
    let flightSegment = dataList.FLIGHTSEGMENTLIST[0].FLIGHTSEGMENT;
    this.mapFlighIds(flightSegment);
    this.mapDisabilityService(serviceDefinitionList);
    this.mapDisabilityServiceScreenData(offersItems);
  }

  mapFlighIds(flightSegment: any) {
    this.flightSegment = [];
    let len = flightSegment?.length;
    if (len > 0) {
      flightSegment.forEach((flightList: any) => {
        this.flightSegment.push(flightList.$.SEGMENTKEY);
        this.disabilityServiceDetails.push({ flightNumber: flightList.$.SEGMENTKEY, disabilityServicedropDownList: [] });
      });
    }
  }

  mapDisabilityService(serviceDefinitionList: any) {
    this.disabilityService = [];
    let len = serviceDefinitionList.length;
    if (len > 0) {
      serviceDefinitionList.forEach((serviceList: any) => {
        if (typeof serviceList.DESCRIPTIONS[0].$ != 'undefined' && serviceList.DESCRIPTIONS[0].$.REFS === 'DisabilityAssistance') {
          this.disabilityServiceRefs.push(serviceList.$.SERVICEDEFINITIONID);
          this.disabilityService.push({ disabilityService: serviceList.NAME[0], disabilityServicekey: serviceList.$.SERVICEDEFINITIONID });
        }
      });
    }
  }

  mapDisabilityServiceScreenData(offersItems: any) {
    for (let items of offersItems) {
      let flightNumbers = items.ELIGIBILITY[0].SEGMENTREFS[0];

      flightNumbers = flightNumbers.split(' ');
      flightNumbers.forEach((flightNumber: any) => {
        let flightDetailIndex: any = this.flightSegment.indexOf(flightNumber);

        let disabilityServiceref = items.SERVICE[0].SERVICEDEFINITIONREF[0];
        let disabilityServiceindex: any = this.disabilityServiceRefs.indexOf(disabilityServiceref);

        if (disabilityServiceindex != -1) {
          this.disabilityServiceDetails[flightDetailIndex].disabilityServicedropDownList.push({
            name: this.disabilityService[disabilityServiceindex].disabilityService,
            price: items.UNITPRICEDETAIL[0].TOTALAMOUNT[0].SIMPLECURRENCYPRICE[0]._
          });
        }
      });
    }
  }
}
